// extracted by mini-css-extract-plugin
module.exports = {"hide":"InvoicesModalUpload_hide__7tIe-","upload__btn":"InvoicesModalUpload_upload__btn__qXaBW"};